
<div class="container">
    <div *ngIf="this.vc_showPhoneUpdate" class="mat-form-field">
      <h1 class="mb-3">Ingrese su número de teléfono</h1>
      <app-phone-input (obj_newPhoneNumber)="fn_updatedPhonenumber($event)" (obj_newNormalizedPhoneNumber)="fn_updatedNormalizedPhonenumber($event)"></app-phone-input>
      <mat-progress-bar *ngIf="this.obj_showProgressBar" mode="indeterminate" class="my-16"></mat-progress-bar>
    </div>
    <div *ngIf="!this.vc_showPhoneUpdate">
      <h1 class="mb-3">{{obj_source == 'login' ? 'Verificación de 2 factores' : 'Verifique su número de teléfono'}}</h1>
      <p>Ingrese el código enviado a su número de teléfono</p>
      <input class="digit" type="text" #num1 id="num1" maxlength="1" name="num1" matInput autofocus
        onkeyup="if (this.value.length == this.getAttribute('maxlength')) { num2.focus(); } "/>&nbsp;&nbsp;
      <input class="digit" type="text" #num2 id="num2" maxlength="1" name="num2" matInput
        onkeyup="if (this.value.length == this.getAttribute('maxlength')) { num3.focus(); }
        else if (this.value.length <= 0) { num1.focus(); } "/>&nbsp;&nbsp;
      <input class="digit" type="text" #num3 id="num3" maxlength="1" name="num3" matInput
        onkeyup="if (this.value.length == this.getAttribute('maxlength')) { num4.focus(); }
        else if (this.value.length <= 0) { num2.focus(); } "/>&nbsp;&nbsp;
      <input class="digit" type="text" #num4 id="num4" maxlength="1" name="num4" matInput
        onkeyup="if (this.value.length == this.getAttribute('maxlength')) { num5.focus(); }
        else if (this.value.length <= 0) { num3.focus(); } "/>&nbsp;&nbsp;
      <input class="digit" type="text" #num5 id="num5" maxlength="1" name="num5" matInput
        onkeyup="if (this.value.length == this.getAttribute('maxlength')) { num6.focus(); }
        else if (this.value.length <= 0) { num4.focus(); } "/>&nbsp;&nbsp;
      <input class="digit" type="text" #num6 id="num6" maxlength="1" name="num6" matInput
        onkeyup=" if (this.value.length <= 0) { num5.focus(); } "/>&nbsp;&nbsp;
    </div>
</div>

<div class="container">
  <button mat-raised-button color="primary" class="mt-16"
    style="font-size: large;font-weight: 400;" (click)="fn_exit()">Regresar
  </button> &nbsp;
  <button mat-raised-button color="primary" class="mt-16"
    style="font-size: large;font-weight: 400;" (click)="fn_confirmButton()">Confirmar
  </button>
</div>

<div class="container" *ngIf="!this.vc_showPhoneUpdate">
  <p style="margin-top: 12px;">
    ¿No recibió el código?
    <a href="#" (click)="$event.preventDefault(); fn_resendCode()"
      [style.pointer-events]="vc_resendCooldown > 0 ? 'none' : 'auto'"
      [style.opacity]="vc_resendCooldown > 0 ? '0.5' : '1'">
      Reenviar código<span *ngIf="vc_resendCooldown > 0"> ({{vc_resendCooldown}}s)</span>
    </a>
  </p>
</div>

<div class="container">
  <div *ngIf="this.obj_canUpdatePhoneNumber && !this.vc_showPhoneUpdate">
    <p>Su número de teléfono aún no ha sido confirmado
      <a href="#" (click)="fn_showPhoneUpdate($event)">¿Desea cambiar su número?</a>
    </p>
  </div>
</div>
